var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import WalletBar from '../../parts/WalletBar.vue';
import { getAccountHttp } from "../../../lib/nisUtils";
import { Address } from "nem-library";
import { WalletsHelper } from "../../../lib/storage";
export default Vue.extend({
    components: { ToolBar, WalletBar },
    name: "WalletSettings",
    props: {
        id: String
    },
    data() {
        return {
            items: [
                {
                    text: this.$t('wallet.settings_detail'),
                    method: this.showDetail
                },
                {
                    text: this.$t('wallet.settings_address'),
                    method: this.showAddress
                },
                {
                    text: this.$t('wallet.settings_backup'),
                    method: this.backup
                },
                {
                    text: this.$t('wallet.settings_rename'),
                    method: this.showRenameDialog
                },
                {
                    text: this.$t('wallet.settings_delete'),
                    method: this.deleteWallet
                },
            ],
            walletType: '',
            renameDialog: false,
            newWalletName: '',
            updateWalletBar: false,
        };
    },
    methods: {
        showDetail() {
            this.$router.push('/wallet/detail?id=' + this.id);
        },
        showAddress() {
            this.$router.push('/wallet/address?id=' + this.id);
        },
        backup() {
            this.$router.push('/wallet/backup_caution?id=' + this.id);
        },
        showRenameDialog() {
            this.newWalletName = '';
            this.renameDialog = true;
        },
        deleteWallet() {
            this.$router.push('/wallet/delete?id=' + this.id);
        },
        rename() {
            return __awaiter(this, void 0, void 0, function* () {
                yield WalletsHelper.setName(this.id, this.newWalletName);
                this.renameDialog = false;
                this.updateWalletBar = true;
            });
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            const accountHttp = getAccountHttp();
            const wallet = yield WalletsHelper.get(this.id);
            if (wallet === null) {
                return;
            }
            const address = new Address(wallet.address);
            // check the address is newbie
            accountHttp.getFromAddress(address).subscribe(accountInfoWithMetaData => {
                if (accountInfoWithMetaData.cosignatories.length > 0) {
                    this.walletType = 'Multisig';
                }
                else {
                    this.walletType = 'Standard';
                }
            }, error => {
                // Error occurs when the account public key is null.
                // This means the account is not multi signature account.
                this.walletType = 'Standard';
            });
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletSettings.vue
// module id = 632
// module chunks = 1